import React, { useEffect } from "react";
import { Route, Routes as ReactRoutes } from "react-router-dom";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import CssBaseline from "@material-ui/core/CssBaseline";
import { prestoMuiTheme } from "@prestosports/commons-ui";
import GameModeLayoutContainer from "../../layout/containers/GameModeLayoutContainer";
import LayoutContainer from "../../layout/containers/LayoutContainer";
import gameMuiTheme from "../../layout/styles/GameMuiTheme";
import OfflineIndicator from "./OfflineIndicator";
import EventIdListener from "./EventIdListener";
import { useAppContext } from "../../../state/app/context";
import { useAuthContext } from "../../../state/authentication/context";
import AppLoadingProgress from "./AppLoadingProgress";
import UnhandledErrorBoundary from "../../errors/components/UnhandledErrorBoundary";

const AppModeSwitcher = () => {
	const { initAppData } = useAppContext();
	const { state } = useAuthContext();
	const isAuthenticated = state.isAuthenticated();

	useEffect(() => {
		if (isAuthenticated) {
			initAppData();
		}
	}, [isAuthenticated]);

	return (
		<ReactRoutes>
			<Route
				path="/cms-event/:eventId"
				element={
					<ThemeProvider theme={gameMuiTheme}>
						<UnhandledErrorBoundary>
							<AppLoadingProgress />
							<EventIdListener />
						</UnhandledErrorBoundary>
					</ThemeProvider>
				}
			/>
			<Route
				path="/event/:eventId/*"
				element={
					<ThemeProvider theme={gameMuiTheme}>
						<UnhandledErrorBoundary>
							<AppLoadingProgress />
							<CssBaseline />
							<GameModeLayoutContainer />
							<OfflineIndicator />
						</UnhandledErrorBoundary>
					</ThemeProvider>
				}
			/>
			<Route
				path="*"
				element={
					<ThemeProvider theme={prestoMuiTheme}>
						<UnhandledErrorBoundary>
							<AppLoadingProgress />
							<CssBaseline />
							<LayoutContainer />
							<OfflineIndicator />
						</UnhandledErrorBoundary>
					</ThemeProvider>
				}
			/>
		</ReactRoutes>
	);
};

export default AppModeSwitcher;
